import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { scheduledLessonsQueryKeys } from '@/data/services/querykeys';
import { updateScheduledLesson } from '@/data/services/scheduledLessonsServices';
import ScheduledLesson from '@/models/ScheduledLesson';
import { getErrorMessage } from '@/utils/getErrorMessage';
import alert from '@/utils/shared/alert';

export default function useScheduledLessonNotes(scheduledLessonId: number) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'scheduledLessonReportModal',
  });

  const { queryKey } = scheduledLessonsQueryKeys.get(scheduledLessonId);
  const cache = useSingleCache<ScheduledLesson>(queryKey);

  const updateMutation = useMutation({
    mutationFn: (notes: string) =>
      updateScheduledLesson(scheduledLessonId, { notes }),
    onSuccess: scheduledLesson => {
      cache.set(scheduledLesson);
      alert.success(t('notesUpdated'));
    },
    onError: err => alert.error(getErrorMessage(err)),
  });

  return {
    updateNotes: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
